import React, { PropsWithChildren, ReactElement } from 'react';
import css from './SearchListResult.module.scss';
import classNames from 'classnames';
import { GMCapitalize, GMUppercase } from '../../Case';
import { textCapitalize } from '../../../helpers/textCapitalize';
import { useLocalization } from '../../../context/Localization/localization';
import { SizedIconProps } from '../../Icon/SizedIcon/SizedIcon.types';
import { GMCheckbox } from '../../Checkbox';
import { GMTitle } from '../../Title';
import { GMGenericButton } from '../../ButtonBase';

export interface IMultiResultListItemProps {
    /**
     * Passes the name of the vehicle for display
     */
    title: string;
    /**
     * Passes the vin
     */
    vinTitle?: string;
    /**
     * Passes the function for an onClick event for the vehicle list
     */
    onClick: () => void;
    /**
     * Passes a boolean for if the checkbox has been selected.
     */
    checked?: boolean;
}

interface ISearchListMultiResultProps {
    /**
     * Passes the name of the individual for display
     */
    title: string;
    /**
     * Passes the name of the vehicle for the vin
     */
    vinTitle?: string;
    /**
     * Passes a list of other items to render to the screen with relevant props
     */
    listItems: IMultiResultListItemProps[];
    /**
     * Passes the icon to display
     */
    icon?: ReactElement<SizedIconProps>;
    /**
     * Passes a boolean for whether or not the customer has a business name
     */
    isBusiness?: boolean;
}

export const SearchListMultiResult: React.FC<PropsWithChildren<ISearchListMultiResultProps>> = React.memo((props) => {
    const Localization = useLocalization();

    return (
        <div className={classNames(css.searchResult, css.multiResult)}>
            <div className={css.information}>
                {props.icon ? <div className={css.icon}>{props.icon}</div> : null}
                <div className={css.content}>
                    <GMTitle headerLevel={5}>
                        {textCapitalize(props.title, props.isBusiness)}
                    </GMTitle>
                    <div>{props.children}</div>
                </div>
            </div>
            {props.listItems.map((listItem, index) => (
                <div className={css.listItem} key={index}>
                    <GMGenericButton
                        onClick={listItem.onClick}
                        title={Localization.ClickToConfirmInformation}
                        id={Localization.ClickToConfirmInformation}
                        ariaLabel={Localization.ClickToConfirmInformation}
                        ariaChecked={listItem.checked}
                    >
                        <div className={css.listItemContent}>
                            <GMTitle headerLevel={5}>
                                <GMCapitalize>{listItem.title}</GMCapitalize>
                                {' '}
                                <GMUppercase>{listItem.vinTitle}</GMUppercase>
                            </GMTitle>
                            <GMCheckbox checked={listItem.checked} iconSize={'medium'} />
                        </div>
                    </GMGenericButton>
                </div>
            ))}
        </div>
    );
});
